/* Base translations · App shell: search, time chip, page names, dialogs, errors, viewer, AI usage, my time, audit trail, storage, packages — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): globalSearch, timeChip, pageNames, nav2, appDialog, errorBoundary, notFound, pdfViewer, dashboardExtras, aiExhausted, aiusage, myTime, auditTrail, platformStorage, storageRecon, pkg. */
export const I18N_BASE_APP_SHELL = {
  en: {
    globalSearch: {
      openItem: "Open the item",
      placeholder: "Search this engagement…  (⌘K / Ctrl-K)",
      recentSearches: "Recent searches",
      startTyping: "Start typing to search across every tab in this engagement.",
      noMatches: "No matches for {q} in this engagement.",
      notApplicable: "Not applicable",
      lastEditedBy: "Last edited by",
      scopedTo: "Scoped to current engagement",
      esc: "Esc",
      toClose: "to close",
      groups: {
        best: "Best match",
        headFolders: "Head folders",
        worksheets: "Worksheets",
        procedures: "Procedures",
        observations: "Observations",
        misstatements: "Misstatements",
        adjustingEntries: "Adjusting entries",
        confirmations: "Confirmations",
        screens: "Screens",
        planning: "Planning",
        riskForms: "Risk Assessment Forms",
        completion: "Completion",
        gl: "GL Data",
        documents: "Documents",
        discrepancies: "Discrepancies",
        samples: "Sampling",
        vouching: "Vouching",
        risk: "Risk Assessment",
        team: "Team",
        auditTrail: "Audit Trail",
      },
      filters: {
        headFolders: "Head folders",
        worksheets: "Worksheets",
        procedures: "Procedures",
        observations: "Observations",
        misstatements: "Misstatements",
        adjustingEntries: "Adjusting entries",
        confirmations: "Confirmations",
        screens: "Screens",
        all: "All",
        forms: "Forms",
        gl: "GL",
        documents: "Documents",
        discrepancies: "Discrepancies",
        samples: "Samples",
        vouching: "Vouching",
        risk: "Risk",
        team: "Team",
        auditTrail: "Audit Trail",
      },
    },
    timeChip: {
      idleHint: "Away from keyboard — auto-tracking will pause the moment your tab closes or the browser sleeps",
      titleFor: "Your time on {name}",
      thisEng: "this engagement",
      onBreak: "on break",
      away: "away",
      panelTitle: "Your time on this engagement",
      panelDesc: "Own hours only — no other users, no rates, no fees.",
      endBreak: "End break",
      takeBreak: "Take a break",
      awayHeader: "Away from keyboard",
      awayLong: "No activity for 5 min. Auto-tracking will pause automatically the moment your tab closes or the browser sleeps. Move the mouse or type to dismiss this notice.",
      autoTrackNotice: "Automatic tracking starts when your WebSocket connection is live (usually a second or two after this engagement is selected). You can still log time manually below.",
      totalLogged: "Total logged",
      addManual: "Add manual entry",
      date: "Date",
      minutes: "Minutes",
      minutesPh: "e.g. 45",
      notePh: "Note (optional)",
      addEntry: "Add entry",
      savingBtn: "Saving…",
      recent: "Recent",
      noEntries: "No entries yet.",
      manualBadge: "manual",
      minSuffix: "min",
      breakEnded: "Break ended — tracking resumed",
      onBreakToast: "On break — tracking paused",
      breakFailed: "Break toggle failed",
      enterMinutes: "Enter minutes",
      addedMin: "Added {n} min",
      addFailed: "Failed",
      deleteConfirm: "Delete this time entry?",
      deleted: "Deleted",
      deleteFailed: "Delete failed",
    },
    // M1/M2 — page display names + auto-matter templates (EN).
    pageNames: {
      "/sampling": "Sampling",
      "/vouching": "Vouching Control / Summary",
      "/confirmations": "Confirmations",
      "/audit-response": "Audit Response Plan",
      "/controls/walkthroughs": "Controls — Walkthroughs",
      "/controls/itgc": "Controls — ITGC",
      "/controls/a9002": "Controls — A9002",
      "/controls/deficiency-log": "Controls — Deficiency log",
      "/fieldwork/a9001": "Fieldwork — A9001 (JE testing)",
      "/fieldwork/a9003": "Fieldwork — A9003 (Opening balances)",
      "/fieldwork/adjusting-entries": "Fieldwork — Adjusting entries",
      "/not-found": "Page not found",
      "/risk": "Risk of Material Misstatement",
      "/reporting/auditors-report": "Auditor's report",
    },
    nav2: {
      risk: "Risk Assessment",
      aging: "Aging",
      ratios: "Ratios",
    },
    appDialog: {   // Batch 15 · N4 (F-118): the one in-app dialog replacing the browser's own boxes
      confirmTitle: "Please confirm", promptTitle: "Enter a value", alertTitle: "Notice",
      required: "Required.", unchanged: "Change the value to save.",
    },
    errorBoundary: {
      title: "Something went wrong on this screen",
      pageCannotLoad: "The page couldn't finish loading. Try again.",
      unexpected: "Unexpected error",
      reload: "Reload page",
    },
    notFound: { title: "Page not found", body: "There is no page at this address.", goHome: "Go to the Dashboard" },
    pdfViewer: { failed: "This document could not be displayed. Try again or download it.", download: "Download" },
    dashboardExtras: {
      noEngagements: "No engagements yet.",
    },
    aiExhausted: {
      title: "AI key consumed",
      desc: "The key is consumed. Please contact Customer Service to issue a new key.",
      noKeyTitle: "No AI key issued",
      noKeyDesc: "No AI key has been issued to this firm. Please contact Customer Service to issue a key.",
    },
    // Batch 16 · Q4 / Q5 (F-123 / F-124): the owner's terms — "Platform key" = a key AZEX provides, "Own key" = the firm's own key
    aiusage: {
      source: { platform: "Platform key", byok: "Own key", unknown: "Not recorded" },
      ownKeyCard: "Own key", ownKeyDialogTitle: "Set your own key",
      ownKeyDialogDesc: "Paste your own AI provider key. AZEX encrypts it at rest and never returns it to the browser again — only the last 4 characters are shown.",
      modeOwn: "Own key", modePlatform: "Platform key", useOwn: "Use my own key", usePlatform: "Use the platform key", rotate: "Rotate key",
      keyNote: "Own key = your own AI provider key authenticates every AI call (billed by your provider). Platform key = a key AZEX provides (invoiced through your allotment above).",
      allKeys: "All active keys", colSource: "Key source",
    },
    myTime: {
      title: "Your time",
      last7: "last 7 days",
      last30: "last 30 days",
      empty: "No time logged in this window yet.",
      moreItems: "+ {n} more…",
    },
    auditTrail: {
      title: "Audit Trail",
      subtitle: "Every action performed inside this engagement, with user, role and time",
      events: "Events",
      empty: "No events yet for this engagement.",
      allTypes: "All activity types",
    },
    platformStorage: {      // Batch 18 · Stage 4 — the mandatory A / B storage choice (Founder → Tenants → New tenant)
      storageTitle: "Where is this firm's data stored?",
      storageChoose: "Choose one — there is no default.",
      storageShared: "A — Shared server",
      storageSharedHint: "The firm gets its own database on the shared MongoDB server.",
      storageDedicated: "B — Dedicated server",
      storageDedicatedHint: "The firm gets its own database on a dedicated MongoDB server (only servers that pass the connection check are listed).",
      storageServer: "Dedicated server",
      storageNoServers: "No dedicated server passes the connection check — add AZEX_TENANT_DB_<NAME>_URL in the hosting settings.",
      storageRequired: "Choose where this firm's data is stored: A — the shared server, or B — a dedicated server.",
      storageServerRequired: "A dedicated server must be chosen from the servers that pass the connection check.",
    },
    storageRecon: {                 // Batch 11 · B10 (F-87) — Founder → Storage Health → Reconcile detail
      showDetail: "Show detail", hideDetail: "Hide detail", exportCsv: "Export CSV",
      missingTitle: "Tracked rows whose S3 object is missing",
      missingHelp: "The database records a file here, but the object is not on S3. These bytes are in Tracked but not in Actual (negative delta).",
      untrackedTitle: "S3 objects with no tracked row",
      untrackedHelp: "The object is on S3, but no database row records it. These bytes are in Actual but not in Tracked (positive delta).",
      colCollection: "Collection", colKey: "Key", colSize: "Size", colEngagement: "Engagement", colStored: "Stored (KSA)",
      none: "None.", capped: "Showing the first {n}; the CSV holds the same rows. Counts and sizes above are complete.",
      reportOnly: "Report only — nothing is changed, moved or deleted.",
      unmappedTitle: "What the “unmapped” rows mean",
      unmappedFolder: "“unmapped (<folder>)” — objects in an S3 folder that belongs to no firm in the database, usually a firm that was deleted while its files stayed on S3.",
      unmappedOrg: "“unmapped (org)” — objects under the firm-level “org” folder (methodology uploads, Disclosure Checklist FS uploads, signed auditor’s reports). Older runs showed them on one line; they are now counted under their firm. A line “unmapped (org:<id>)” means the firm with that id no longer exists.",
      unmappedOrgId: "“unmapped-org (<id>)” — rows in the database that name a firm id with no firm record.",
      rerun: "Run Reconcile again to see the detail.",
    },
    // Batch 14 · M15 — engagement backup package (.azex)
    pkg: {
      title: "Backup package", desc: "A local safety copy of this engagement's audit work — settings, team, forms, worksheets, risks, procedures, walkthroughs, samples and vouching results, misstatements, adjusting entries, W10 / W11 / W12, EQ review, KAM, Other Information, sign-offs, review points, audit trail and the auditor's report text. It can be loaded back only into AZEX, into your own firm, always as a NEW engagement.",
      excluded: "Not in the package: the client ledger / trial balance / sub-ledgers and every client support file (documents, attachments, confirmations, pack files). The package lists them by name, size and hash — upload them again after a restore.",
      security: "Sealed and signed by AZEX with a firm-scoped key; any change to the file is detected and the upload refused. A fresh one-time code to your e-mail is asked for the download; each download is on the Audit Trail with the package hash.",
      build: "Make a package", building: "Making the package…", queued: "Queued", ready: "Package ready", failed: "The package could not be made", list: "Packages of this engagement", none: "No package yet.", download: "Download", downloaded: "Package downloaded", lockedFile: "Final / locked file",
      restore: "Restore from package", restoring: "Restoring…", restored: "Restored as a new engagement: {name}", restoreFailed: "The package could not be restored",
      missingBanner: "Ledger and client documents not included — upload them again",
      restoredBadge: "Restored", showFiles: "Show the files", hideFiles: "Hide the files", dismissNote: "Hide for this session",   // Batch 15 · N6
    },
  },
  ar: {
    globalSearch: {
      openItem: "افتح العنصر",
      placeholder: "ابحث في هذه المهمة…  (⌘K / Ctrl-K)",
      recentSearches: "عمليات البحث الأخيرة",
      startTyping: "ابدأ الكتابة للبحث في كل تبويبات هذه المهمة.",
      noMatches: "لا توجد مطابقات لـ {q} في هذه المهمة.",
      notApplicable: "لا ينطبق",
      lastEditedBy: "آخر تعديل بواسطة",
      scopedTo: "ضمن نطاق المهمة الحالية",
      esc: "Esc",
      toClose: "للإغلاق",
      groups: {
        best: "أفضل تطابق",
        headFolders: "مجلدات البنود",
        worksheets: "أوراق العمل",
        procedures: "الإجراءات",
        observations: "الملاحظات",
        misstatements: "التحريفات",
        adjustingEntries: "قيود التسوية",
        confirmations: "المصادقات",
        screens: "الشاشات",
        planning: "التخطيط",
        riskForms: "نماذج تقييم المخاطر",
        completion: "الإنجاز",
        gl: "بيانات الأستاذ",
        documents: "المستندات",
        discrepancies: "الاختلافات",
        samples: "أخذ العينات",
        vouching: "التوثيق",
        risk: "تقييم المخاطر",
        team: "الفريق",
        auditTrail: "سجل التدقيق",
      },
      filters: {
        headFolders: "مجلدات البنود",
        worksheets: "أوراق العمل",
        procedures: "الإجراءات",
        observations: "الملاحظات",
        misstatements: "التحريفات",
        adjustingEntries: "قيود التسوية",
        confirmations: "المصادقات",
        screens: "الشاشات",
        all: "الكل",
        forms: "النماذج",
        gl: "الأستاذ",
        documents: "المستندات",
        discrepancies: "الاختلافات",
        samples: "العينات",
        vouching: "التوثيق",
        risk: "المخاطر",
        team: "الفريق",
        auditTrail: "سجل التدقيق",
      },
    },
    timeChip: {
      idleHint: "بعيد عن لوحة المفاتيح — سيتوقف التتبع التلقائي فور إغلاق التبويب أو سكون المتصفح",
      titleFor: "وقتك على {name}",
      thisEng: "هذه المهمة",
      onBreak: "في استراحة",
      away: "غائب",
      panelTitle: "وقتك على هذه المهمة",
      panelDesc: "الساعات الخاصة بك فقط — بدون مستخدمين آخرين، أو أسعار، أو أتعاب.",
      endBreak: "إنهاء الاستراحة",
      takeBreak: "خذ استراحة",
      awayHeader: "بعيد عن لوحة المفاتيح",
      awayLong: "لا يوجد نشاط منذ 5 دقائق. سيتوقف التتبع التلقائي فور إغلاق التبويب أو سكون المتصفح. حرّك الفأرة أو اكتب لإخفاء هذا التنبيه.",
      autoTrackNotice: "يبدأ التتبع التلقائي عندما يكون اتصال WebSocket نشطاً (عادةً بعد ثانية أو ثانيتين من اختيار المهمة). يمكنك مع ذلك تسجيل الوقت يدوياً أدناه.",
      totalLogged: "الإجمالي المسجّل",
      addManual: "إضافة قيد يدوي",
      date: "التاريخ",
      minutes: "الدقائق",
      minutesPh: "مثال: 45",
      notePh: "ملاحظة (اختياري)",
      addEntry: "إضافة قيد",
      savingBtn: "جاري الحفظ…",
      recent: "الحديثة",
      noEntries: "لا توجد قيود بعد.",
      manualBadge: "يدوي",
      minSuffix: "دقيقة",
      breakEnded: "انتهت الاستراحة — استؤنف التتبع",
      onBreakToast: "في استراحة — التتبع متوقف",
      breakFailed: "فشل تبديل الاستراحة",
      enterMinutes: "أدخل الدقائق",
      addedMin: "تمت إضافة {n} دقيقة",
      addFailed: "فشل",
      deleteConfirm: "حذف هذا القيد؟",
      deleted: "تم الحذف",
      deleteFailed: "فشل الحذف",
    },
    // M1/M2 — page display names + auto-matter templates (AR).
    pageNames: {
      "/sampling": "العيّنات",
      "/vouching": "التدقيق المستندي — الملخّص",
      "/confirmations": "المصادقات",
      "/audit-response": "خطة الاستجابة للمخاطر",
      "/controls/walkthroughs": "الرقابة — التتبّع الميداني",
      "/controls/itgc": "الرقابة — ضوابط تقنية المعلومات",
      "/controls/a9002": "الرقابة — \u2066A9002\u2069",
      "/controls/deficiency-log": "الرقابة — سجل جوانب القصور",
      "/fieldwork/a9001": "العمل الميداني — \u2066A9001\u2069",
      "/fieldwork/a9003": "العمل الميداني — \u2066A9003\u2069",
      "/fieldwork/adjusting-entries": "العمل الميداني — قيود التسوية",
      "/not-found": "الصفحة غير موجودة",
      "/risk": "تقييم مخاطر التحريف الجوهري",
      "/reporting/auditors-report": "تقرير المراجع",
    },
    nav2: {
      risk: "تقييم المخاطر",
      aging: "الأعمار",
      ratios: "النسب",
    },
    appDialog: {
      confirmTitle: "يرجى التأكيد", promptTitle: "أدخل قيمة", alertTitle: "تنبيه",
      required: "مطلوب.", unchanged: "غيّر القيمة للحفظ.",
    },
    errorBoundary: {
      title: "حدث خطأ ما في هذه الشاشة",
      pageCannotLoad: "تعذّر إكمال تحميل الصفحة. حاول مرة أخرى.",
      unexpected: "خطأ غير متوقع",
      reload: "إعادة تحميل الصفحة",
    },
    notFound: { title: "الصفحة غير موجودة", body: "لا توجد صفحة على هذا العنوان.", goHome: "الانتقال إلى لوحة التحكم" },
    pdfViewer: { failed: "تعذر عرض هذا المستند. حاول مرة أخرى أو قم بتنزيله.", download: "تنزيل" },
    dashboardExtras: {
      noEngagements: "لا توجد مهام بعد.",
    },
    aiExhausted: {
      title: "تم استهلاك مفتاح الذكاء الاصطناعي",
      desc: "تم استهلاك المفتاح. يرجى التواصل مع خدمة العملاء لإصدار مفتاح جديد.",
      noKeyTitle: "لم يُصدر مفتاح ذكاء اصطناعي",
      noKeyDesc: "لم يُصدر مفتاح ذكاء اصطناعي لهذه الشركة. يرجى التواصل مع خدمة العملاء لإصدار مفتاح.",
    },
    aiusage: {
      source: { platform: "مفتاح المنصة", byok: "مفتاح خاص", unknown: "غير مسجَّل" },
      ownKeyCard: "مفتاح خاص", ownKeyDialogTitle: "تعيين مفتاحك الخاص",
      ownKeyDialogDesc: "الصق مفتاح مزوّد الذكاء الاصطناعي الخاص بك. تشفّره AZEX عند التخزين ولا تعيده إلى المتصفح مرة أخرى — تُعرض آخر 4 أحرف فقط.",
      modeOwn: "مفتاح خاص", modePlatform: "مفتاح المنصة", useOwn: "استخدام مفتاحي الخاص", usePlatform: "استخدام مفتاح المنصة", rotate: "تدوير المفتاح",
      keyNote: "مفتاح خاص = مفتاح مزوّد الذكاء الاصطناعي الخاص بك يُستخدم في كل استدعاء (تفوتره جهة المزوّد لديك). مفتاح المنصة = مفتاح توفّره AZEX (يُحتسب من مخصصك أعلاه).",
      allKeys: "كل المفاتيح النشطة", colSource: "مصدر المفتاح",
    },
    myTime: {
      title: "وقتك",
      last7: "آخر 7 أيام",
      last30: "آخر 30 يوماً",
      empty: "لم يتم تسجيل أي وقت في هذه الفترة بعد.",
      moreItems: "+ {n} أخرى…",
    },
    auditTrail: {
      title: "سجل التدقيق",
      subtitle: "كل إجراء تم داخل هذه المهمة مع المستخدم والدور والوقت",
      events: "الأحداث",
      empty: "لا توجد أحداث بعد لهذه المهمة.",
      allTypes: "كل الأنواع",
    },
    platformStorage: {
      storageTitle: "أين تُخزَّن بيانات هذه الشركة؟",
      storageChoose: "اختر خيارًا واحدًا — لا يوجد خيار افتراضي.",
      storageShared: "أ — خادم مشترك",
      storageSharedHint: "تحصل الشركة على قاعدة بيانات خاصة بها على خادم MongoDB المشترك.",
      storageDedicated: "ب — خادم مخصص",
      storageDedicatedHint: "تحصل الشركة على قاعدة بيانات خاصة بها على خادم MongoDB مخصص (تُعرض الخوادم التي اجتازت فحص الاتصال فقط).",
      storageServer: "الخادم المخصص",
      storageNoServers: "لا يوجد خادم مخصص اجتاز فحص الاتصال — أضف AZEX_TENANT_DB_<NAME>_URL في إعدادات الاستضافة.",
      storageRequired: "اختر مكان تخزين بيانات هذه الشركة: أ — الخادم المشترك، أو ب — خادم مخصص.",
      storageServerRequired: "يجب اختيار خادم مخصص من الخوادم التي اجتازت فحص الاتصال.",
    },
    storageRecon: {
      showDetail: "عرض التفاصيل", hideDetail: "إخفاء التفاصيل", exportCsv: "تصدير CSV",
      missingTitle: "سجلات متتبَّعة لا يوجد كائنها على S3",
      missingHelp: "تسجّل قاعدة البيانات ملفاً هنا، لكن الكائن غير موجود على S3. هذه البايتات ضمن المتتبَّع وليست ضمن الفعلي (فرق سالب).",
      untrackedTitle: "كائنات على S3 بلا سجل متتبَّع",
      untrackedHelp: "الكائن موجود على S3، لكن لا يسجّله أي سجل في قاعدة البيانات. هذه البايتات ضمن الفعلي وليست ضمن المتتبَّع (فرق موجب).",
      colCollection: "المجموعة", colKey: "المفتاح", colSize: "الحجم", colEngagement: "الارتباط", colStored: "تاريخ الحفظ (توقيت السعودية)",
      none: "لا يوجد.", capped: "يُعرض أول {n}؛ ويحتوي ملف CSV على الصفوف نفسها. الأعداد والأحجام أعلاه كاملة.",
      reportOnly: "تقرير فقط — لا يُغيَّر أو يُنقل أو يُحذف أي شيء.",
      unmappedTitle: "معنى صفوف «غير مربوط»",
      unmappedFolder: "«unmapped (<folder>)» — كائنات في مجلد على S3 لا يخص أي منشأة في قاعدة البيانات، وغالباً منشأة حُذفت وبقيت ملفاتها على S3.",
      unmappedOrg: "«unmapped (org)» — كائنات تحت مجلد «org» على مستوى المنشأة (ملفات المنهجية، وملفات القوائم المالية لقائمة الإفصاح، وتقارير المدقق الموقّعة). كانت التشغيلات السابقة تعرضها في سطر واحد؛ وهي الآن تُحسب ضمن منشأتها. ويعني السطر «unmapped (org:<id>)» أن المنشأة بهذا المعرّف لم تعد موجودة.",
      unmappedOrgId: "«unmapped-org (<id>)» — سجلات في قاعدة البيانات تشير إلى معرّف منشأة لا يوجد لها سجل.",
      rerun: "شغّل المطابقة مرة أخرى لعرض التفاصيل.",
    },
    pkg: {
      title: "حزمة النسخ الاحتياطي", desc: "نسخة أمان محلية لأعمال المراجعة في هذا الارتباط — الإعدادات والفريق والنماذج وأوراق العمل والمخاطر والإجراءات والجولات والعينات ونتائج المطابقة والتحريفات وقيود التسوية وW10 / W11 / W12 ومراجعة الجودة وKAM والمعلومات الأخرى والتوقيعات ونقاط المراجعة وسجل التدقيق ونص تقرير المدقق. لا تُحمَّل إلا في AZEX، وفي شركتك فقط، ودائمًا كارتباط جديد.",
      excluded: "ليس في الحزمة: دفتر الأستاذ / ميزان المراجعة / الدفاتر الفرعية للعميل وكل ملفات الدعم الخاصة بالعميل (المستندات والمرفقات والمصادقات وملفات الحزمة). تدرجها الحزمة بالاسم والحجم والبصمة — أعد رفعها بعد الاستعادة.",
      security: "مختومة وموقّعة من AZEX بمفتاح خاص بالشركة؛ يُكتشف أي تغيير في الملف ويُرفض الرفع. يُطلب رمز لمرة واحدة إلى بريدك عند التنزيل؛ ويُسجَّل كل تنزيل في سجل التدقيق مع بصمة الحزمة.",
      build: "إنشاء حزمة", building: "جارٍ إنشاء الحزمة…", queued: "في قائمة الانتظار", ready: "الحزمة جاهزة", failed: "تعذّر إنشاء الحزمة", list: "حزم هذا الارتباط", none: "لا توجد حزمة بعد.", download: "تنزيل", downloaded: "تم تنزيل الحزمة", lockedFile: "ملف نهائي / مقفل",
      restore: "استعادة من حزمة", restoring: "جارٍ الاستعادة…", restored: "استُعيد كارتباط جديد: {name}", restoreFailed: "تعذّرت استعادة الحزمة",
      missingBanner: "دفتر الأستاذ ومستندات العميل غير مضمّنة — أعد رفعها",
      restoredBadge: "مستعاد", showFiles: "عرض الملفات", hideFiles: "إخفاء الملفات", dismissNote: "إخفاء لهذه الجلسة",   // Batch 15 · N6
    },
  },
};

export default I18N_BASE_APP_SHELL;
